import React, { useEffect } from 'react';
import { clearQueueScrollLocks, disablePageScroll, enablePageScroll } from 'scroll-lock';
import { MarkdownCopy } from '../MarkdownCopy';
import { useBreakpoint } from '../../utils/react/useBreakpoint';
import styled, { css, keyframes } from 'styled-components';
import { mediaMaxWidth } from '../../utils';
const animation = keyframes`
 0% { width: 0; }
 100% { width: 50% }
`;
const animationMobile = keyframes`
 0% { width: 0; }
 100% { width: 100% }
`;
const StyledDrawer = styled.div`
  animation: slide 0.4s ease;
  animation-name: ${animation};
  background-color: #fff;
  box-shadow: 0px 0px 16px rgba(44, 53, 71, 0.2);
  display: flex;
  height: 100vh;
  padding: 64px 32px;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 11;
  width: 50%;

  ${mediaMaxWidth({
  sm: css`
      animation-name: ${animationMobile};
      padding: 32px 16px;
      width: 100%;
      height: 70vh;
    `
})}
`;
const DrawerScroll = styled.div`
  max-height: 100vh;
  overflow-y: auto;

  ${mediaMaxWidth({
  sm: css`
      max-height: 70vh;
    `
})}
`;
const DrawerButton = styled.button`
  position: absolute;
  background-color: transparent;
  background-image: none;
  border: 0;
  right: 32px;
  top: 32px;

  ${mediaMaxWidth({
  sm: css`
      right: 16px;
      top: 16px;
    `
})}
`;

const Drawer = ({
  children,
  onClose
}) => {
  const breakpoint = useBreakpoint();
  useEffect(() => {
    const onEscapeListener = e => {
      if (e.keyCode === 27) {
        onClose();
      }
    };

    window.addEventListener('keydown', onEscapeListener);
    return () => {
      window.removeEventListener('keydown', onEscapeListener);
    };
  }, [onClose]);
  useEffect(() => {
    disablePageScroll();
    return () => {
      clearQueueScrollLocks();
      enablePageScroll();
    };
  }, [breakpoint]);
  return /*#__PURE__*/React.createElement(StyledDrawer, {
    id: "drawer",
    "data-testid": "drawer",
    role: "none"
  }, /*#__PURE__*/React.createElement(DrawerButton, {
    "data-testid": "drawer-close",
    type: "button",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    alt: "close",
    src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik0xMy4zLjdhMSAxIDAgMDAtMS40IDBMNyA1LjYgMi4xLjdBMSAxIDAgMTAuNyAyLjFMNS42IDcgLjcgMTEuOWExIDEgMCAxMDEuNCAxLjRMNyA4LjRsNC45IDQuOWExIDEgMCAxMDEuNC0xLjRMOC40IDdsNC45LTQuOWMuNC0uNC40LTEgMC0xLjR6IiBpZD0iYSIvPjwvZGVmcz48dXNlIGZpbGw9IiMwMDAiIHhsaW5rOmhyZWY9IiNhIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K",
    height: 14,
    width: 14
  })), /*#__PURE__*/React.createElement(DrawerScroll, {
    "data-scroll-lock-scrollable": true
  }, typeof children !== 'string' ? children : /*#__PURE__*/React.createElement(MarkdownCopy, {
    source: children
  })));
};

export default Drawer;